
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty } from "../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { UpdateDashboardConfigurationDto, DashboardBlockConfiguration, DashboardBlockModule_key } from "../Shared/DashboardConfiguration.js";
import { ofArray, map, singleton, append, filter, insertAt, tryFindIndex, tryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { map as map_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { deleteNotification } from "../Requests/Notification.js";
import { Cmd_errorToast, Cmd_successToast } from "../Components/Toast.js";
import { Cmd_resetConfiguration, Cmd_updateConfiguration } from "../Requests/Dashboard.js";

export function init() {
    return [new State(FormState_get_empty(), undefined, undefined, false), Cmd_none()];
}

function isBlock(block, entry) {
    return DashboardBlockModule_key(entry.Block) === DashboardBlockModule_key(block);
}

export function moveBlock(source, target, blocks) {
    let targetIndex, moved;
    const matchValue = tryFind((entry) => isBlock(source, entry), blocks);
    const matchValue_1 = tryFindIndex((entry_1) => isBlock(target, entry_1), blocks);
    let matchResult, moved_1, targetIndex_1;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            if ((targetIndex = (matchValue_1 | 0), (moved = matchValue, DashboardBlockModule_key(source) !== DashboardBlockModule_key(target)))) {
                matchResult = 0;
                moved_1 = matchValue;
                targetIndex_1 = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return insertAt(targetIndex_1, moved_1, filter((arg) => !isBlock(source, arg), blocks));
        default:
            return blocks;
    }
}

export function showBlock(block, blocks) {
    const matchValue = tryFind((entry) => isBlock(block, entry), blocks);
    if (matchValue == null) {
        return blocks;
    }
    else {
        const shown = matchValue;
        return append(filter((arg) => !isBlock(block, arg), blocks), singleton(new DashboardBlockConfiguration(shown.Block, shown.Size, true)));
    }
}

function updateBlock(block, change, blocks) {
    return map((entry) => {
        if (isBlock(block, entry)) {
            return change(entry);
        }
        else {
            return entry;
        }
    }, blocks);
}

function withDraft(state, change) {
    return [new State(state.FormState, state.NotificationToDelete, map_1(change, state.Draft), state.IsResetDialogOpen), Cmd_none()];
}

export function update(onDeleteSuccess, onConfigurationChanged, msg, state) {
    let matchValue_2;
    switch (msg.tag) {
        case 1: {
            const matchValue = state.NotificationToDelete;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const notificationId_1 = matchValue;
                return [new State(FormState__startLoading(state.FormState), state.NotificationToDelete, state.Draft, state.IsResetDialogOpen), deleteNotification(notificationId_1, (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(16, [Item_1])))];
            }
        }
        case 2:
            return [new State(state.FormState, undefined, state.Draft, state.IsResetDialogOpen), Cmd_none()];
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.NotificationToDelete, state.Draft, state.IsResetDialogOpen), Cmd_none()];
            }
            else {
                return [new State(FormState_get_empty(), undefined, state.Draft, state.IsResetDialogOpen), Cmd_batch(ofArray([Cmd_successToast("general.deleted_successfully"), Cmd_ofEffect((_arg) => {
                    onDeleteSuccess();
                })]))];
            }
        }
        case 4:
            return [new State(state.FormState, state.NotificationToDelete, msg.fields[0], state.IsResetDialogOpen), Cmd_none()];
        case 5:
            return withDraft(state, (blocks_1) => moveBlock(msg.fields[0], msg.fields[1], blocks_1));
        case 6:
            return withDraft(state, (blocks_2) => updateBlock(msg.fields[0], (entry) => (new DashboardBlockConfiguration(entry.Block, entry.Size, false)), blocks_2));
        case 7:
            return withDraft(state, (blocks_3) => showBlock(msg.fields[0], blocks_3));
        case 8:
            return withDraft(state, (blocks_4) => updateBlock(msg.fields[0], (entry_1) => (new DashboardBlockConfiguration(entry_1.Block, msg.fields[1], entry_1.Visible)), blocks_4));
        case 9:
            return [new State(state.FormState, state.NotificationToDelete, undefined, state.IsResetDialogOpen), Cmd_none()];
        case 10: {
            const matchValue_1 = state.Draft;
            if (matchValue_1 == null) {
                return [state, Cmd_none()];
            }
            else {
                const blocks_5 = matchValue_1;
                return [new State(FormState__startLoading(state.FormState), state.NotificationToDelete, state.Draft, state.IsResetDialogOpen), Cmd_updateConfiguration(new UpdateDashboardConfigurationDto(blocks_5), (Item_2) => (new Msg(11, [Item_2])), (Item_3) => (new Msg(16, [Item_3])))];
            }
        }
        case 11: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                const validationResponse_1 = response_1.fields[0];
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, validationResponse_1), state.NotificationToDelete, state.Draft, state.IsResetDialogOpen), (matchValue_2 = validationResponse_1.GlobalValidationMessage, (matchValue_2 == null) ? Cmd_none() : Cmd_errorToast(matchValue_2))];
            }
            else {
                return [new State(FormState_get_empty(), state.NotificationToDelete, undefined, state.IsResetDialogOpen), Cmd_batch(ofArray([Cmd_ofEffect((_arg_1) => {
                    onConfigurationChanged(response_1.fields[0]);
                }), Cmd_successToast("dashboard.configuration.saved")]))];
            }
        }
        case 12:
            return [new State(state.FormState, state.NotificationToDelete, state.Draft, true), Cmd_none()];
        case 13:
            return [new State(state.FormState, state.NotificationToDelete, state.Draft, false), Cmd_none()];
        case 14:
            return [new State(FormState__startLoading(state.FormState), state.NotificationToDelete, state.Draft, state.IsResetDialogOpen), Cmd_resetConfiguration((Item_4) => (new Msg(15, [Item_4])), (Item_5) => (new Msg(16, [Item_5])))];
        case 15: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.NotificationToDelete, state.Draft, false), Cmd_none()];
            }
            else {
                return [new State(FormState_get_empty(), state.NotificationToDelete, undefined, false), Cmd_batch(ofArray([Cmd_ofEffect((_arg_2) => {
                    onConfigurationChanged(response_2.fields[0]);
                }), Cmd_successToast("dashboard.configuration.reset_done")]))];
            }
        }
        case 16:
            return [new State(FormState_get_empty(), undefined, state.Draft, false), Cmd_errorToast("general.error")];
        default:
            return [new State(state.FormState, msg.fields[0], state.Draft, state.IsResetDialogOpen), Cmd_none()];
    }
}

